export enum PhoneNumberFormat {
  International = 'INTERNATIONAL',
  National = 'NATIONAL',
}
